import {
    GET_ACCOUNTS_FAIL,
    GET_ACCOUNTS_SUCCESS,
    ADD_ACCOUNT_SUCCESS,
    ADD_ACCOUNT_FAIL,

    UPDATE_ACCOUNT_SUCCESS,
    UPDATE_ACCOUNT_FAIL,

    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAIL,

    DELETE_ACCOUNT_SUCCESS,
    DELETE_ACCOUNT_FAIL,

    // SEND INVITATION
    SEND_INVITATION_SUCCESS,
    SEND_INVITATION_FAIL,

    // RESEND INVITATION
    RESEND_INVITATION_SUCCESS,
    RESEND_INVITATION_FAIL,

    // ACCEPT INVITATION
    ACCEPT_INVITATION,
    ACCEPT_INVITATION_SUCCESS,
    ACCEPT_INVITATION_FAIL,

    // RESEND INVITATION CODE
    RESEND_INVITATION_CODE,
    RESEND_INVITATION_CODE_SUCCESS,
    RESEND_INVITATION_CODE_FAIL,

     // CREATE PASSWORD
    CREATE_PASSWORD_SUCCESS,
    CREATE_PASSWORD_FAIL,

    // LOCK ACCOUNT
    LOCK_ACCOUNT,
    LOCK_ACCOUNT_SUCCESS,
    LOCK_ACCOUNT_FAIL,

    // UNLOCK ACCOUNT
    UNLOCK_ACCOUNT,
    UNLOCK_ACCOUNT_SUCCESS,
    UNLOCK_ACCOUNT_FAIL,

    // ENABLE TWO FACTOR
    ENABLE_TWO_FACTOR,
    ENABLE_TWO_FACTOR_SUCCESS,
    ENABLE_TWO_FACTOR_FAIL,

     // DISABLE TWO FACTOR
    DISABLE_TWO_FACTOR,
    DISABLE_TWO_FACTOR_SUCCESS,
    DISABLE_TWO_FACTOR_FAIL,

     // VERIFY TWO FACTOR
    VERIFY_TWO_FACTOR,
    VERIFY_TWO_FACTOR_SUCCESS,
    VERIFY_TWO_FACTOR_FAIL,

    RESEND_TWO_FACTOR_CODE,
    RESEND_TWO_FACTOR_CODE_SUCCESS,
    RESEND_TWO_FACTOR_CODE_FAIL,
   
} from "./actionTypes";

const INIT_STATE = {
    accounts: [],
    error: {},
    loading: true,

    // État spécifique pour l'acceptation de l'invitation
    acceptInvitationLoading: false,
    acceptInvitationError: null,
    
    // État spécifique pour le renvoi du code (peut être combiné ou séparé)
    resendLoading: false,
    resendError: null,
    
    // Informations générales sur l'utilisateur après succès (si nécessaire)
    invitationData: null, 
}

const accountReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ACCOUNTS_SUCCESS:
            return {
                ...state,
                accounts: action.payload,
                loading: true
            };

        case GET_ACCOUNTS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case ADD_ACCOUNT_SUCCESS:
            return {
                ...state,
                accounts: [action.payload, ...state.accounts],
            };

        case ADD_ACCOUNT_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                accounts: state.accounts.map(account =>
                    account.id.toString() === action.payload.id.toString()
                        ? { account, ...action.payload }
                        : account
                ),
            };

        case UPDATE_ACCOUNT_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                accounts: state.accounts.map(account =>
                    account.id.toString() === action.payload.id.toString()
                        ? { account, ...action.payload }
                        : account
                ),
            };

        case CHANGE_PASSWORD_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_ACCOUNT_SUCCESS:
            return {
                ...state,
                accounts: state.accounts.filter(
                    
                    account => account.id !== action.payload
                   
                ),
            };

        case DELETE_ACCOUNT_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        // SEND INVITATION
        case SEND_INVITATION_SUCCESS:
            return {
                ...state,
                accounts: [action.payload, ...state.accounts],
            };

        case SEND_INVITATION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

         // RESEND INVITATION
        case RESEND_INVITATION_SUCCESS:
            return {
                ...state,
                //accounts: [action.payload, ...state.accounts],
            };

        case RESEND_INVITATION_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        
        
        
        
        // ACCEPT INVITATION
        case ACCEPT_INVITATION:
            return {
                ...state,
                acceptInvitationLoading: true,
                acceptInvitationError: null, 
            };

        case ACCEPT_INVITATION_SUCCESS:
            return {
                ...state,
                acceptInvitationLoading: false,
                invitationData: action.payload, // Stocke les données de l'invitation acceptée
                acceptInvitationError: null,
            };

        case ACCEPT_INVITATION_FAIL:
            return {
                ...state,
                acceptInvitationLoading: false,
                acceptInvitationError: action.payload, // Stocke le message d'erreur
            };
            
        // RESEND INVITATION CODE
        
        case RESEND_INVITATION_CODE:
            return {
                ...state,
                resendLoading: true,
                resendError: null,
            };

        case RESEND_INVITATION_CODE_SUCCESS:
            // Le succès ne modifie que le statut de chargement. 
            // La notification est gérée par Saga (Toastify).
            return {
                ...state,
                resendLoading: false,
                resendError: null,
            };

        case RESEND_INVITATION_CODE_FAIL:
            return {
                ...state,
                resendLoading: false,
                resendError: action.payload, // Stocke l'erreur de renvoi
            };

        // CREATE PASSWORD
        case CREATE_PASSWORD_SUCCESS:
            return {
                ...state,
                accounts: [action.payload, ...state.accounts],
            };

        case CREATE_PASSWORD_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        // LOCK ACCOUNT
        case LOCK_ACCOUNT:
            return {
                ...state,
                loading: true,
                error: null,
            };

  
        case LOCK_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                accounts: state.accounts.map(account =>
                String(account.uid) === String(action.payload.uid)
                    ? { ...account, access_locked: true }
                    : account
                ),
            };

        
        case LOCK_ACCOUNT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


        // UNLOCK ACCOUNT
        case UNLOCK_ACCOUNT:
            return {
                ...state,
                loading: true,
                error: null,
            };

  
        case UNLOCK_ACCOUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                accounts: state.accounts.map(account =>
                    String(account.uid) === String(action.payload.uid)
                        ? { ...account, access_locked: false }
                        : account
                    ),
            };

        
        case UNLOCK_ACCOUNT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


        // ENABLE TWO FACTOR
        case ENABLE_TWO_FACTOR:
            return {
                ...state,
                loading: true,
                error: null,
            };

  
        case ENABLE_TWO_FACTOR_SUCCESS:
            return {
                ...state,
                loading: false,
                accounts: state.accounts.map(account =>
                    String(account.uid) === String(action.payload.uid)
                        ? { ...account, access_locked: false }
                        : account
                    ),
            };

        
        case ENABLE_TWO_FACTOR_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        // DISABLE TWO FACTOR
        case DISABLE_TWO_FACTOR:
            return {
                ...state,
                loading: true,
                error: null,
            };

  
        case DISABLE_TWO_FACTOR_SUCCESS:
            return {
                ...state,
                loading: false,
                accounts: state.accounts.map(account =>
                    String(account.uid) === String(action.payload.uid)
                        ? { ...account, access_locked: false }
                        : account
                    ),
            };

        
        case DISABLE_TWO_FACTOR_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

            // Début de la vérification OTP
        case VERIFY_TWO_FACTOR:
            return {
                ...state,
                loading: true,
                error: null,
            };

        // OTP valide
        case VERIFY_TWO_FACTOR_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload,         // access_token + account
                twoFactorVerified: true,
                error: null,
            };

        // OTP invalide
        case VERIFY_TWO_FACTOR_FAIL:
            return {
                ...state,
                loading: false,
                twoFactorVerified: false,
                error: action.payload,        // message d'erreur
            };

        // RESEND TWO FACTOR CODE
        
        case RESEND_TWO_FACTOR_CODE:
            return {
                ...state,
                resendLoading: true,
                resendError: null,
            };

        case RESEND_TWO_FACTOR_CODE_SUCCESS:
            // Le succès ne modifie que le statut de chargement. 
            // La notification est gérée par Saga (Toastify).
            return {
                ...state,
                resendLoading: false,
                resendError: null,
            };

        case RESEND_TWO_FACTOR_CODE_FAIL:
            return {
                ...state,
                resendLoading: false,
                resendError: action.payload, // Stocke l'erreur de renvoi
            };

        default:
            return state
    }
}

export default accountReducer;